import { selectIssueTypeById } from "@overmap-ai/core"
import { cx } from "class-variance-authority"
import { memo } from "react"

import { modelIconNameMapping } from "../../mappings/icons"
import { useAppSelector } from "../../store"
import { DEFAULT_MAX_ICONS } from "./constants"
import { LuDynamicIconWithWrapper, type LuDynamicIconWithWrapperProps } from "./LuDynamicIconWithWrapper"
import type { IconsProps, IconType } from "./typings"

interface IssueTypeIconProps extends Omit<LuDynamicIconWithWrapperProps, "color" | "icon" | "fallback"> {
	issueTypeId: string
}

export const IssueTypeIcon = memo<IssueTypeIconProps>((props) => {
	const { ref, issueTypeId, background = true, ...rest } = props

	const issueType = useAppSelector(selectIssueTypeById(issueTypeId))

	return (
		<LuDynamicIconWithWrapper
			ref={ref}
			color={issueType?.color}
			icon={(issueType?.icon ?? modelIconNameMapping.issueType) as IconType}
			background={background}
			{...rest}
		/>
	)
})
IssueTypeIcon.displayName = "IssueTypeIcon"

interface IssueTypeIconsProps extends IconsProps {
	issueTypeIds: string[]
}

export const IssueTypeIcons = memo<IssueTypeIconsProps>((props) => {
	const { ref, className, issueTypeIds, max = DEFAULT_MAX_ICONS, ...rest } = props

	return (
		<span ref={ref} className={cx("flex -space-x-2", className)} {...rest}>
			{issueTypeIds.slice(0, max ?? issueTypeIds.length).map((issueTypeId) => (
				<IssueTypeIcon issueTypeId={issueTypeId} key={issueTypeId} />
			))}
		</span>
	)
})
IssueTypeIcons.displayName = "IssueTypeIcons"
